










































































































































import Vue from "vue";

import { DataTableHeader } from "vuetify";
import { DataAttribute } from "@/model/DataViewConfigurationHelper";

export default Vue.extend({
  name: "ItemTable",
  props: {
    items: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    showSwitchMetaEditButton: {
      type: Boolean
    },
    isMetaEdit: {
      type: Boolean
    },
    dataAttributes: {
      type: Array as () => DataAttribute[]
    }
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    headers(): DataTableHeader[] {
      if (!this.dataAttributes) {
        return [];
      }
      const headers: DataTableHeader[] = [
        ...this.dataAttributes.map<DataTableHeader>(attribute => {
          return {
            text: attribute.label,
            value: `attributes.${attribute.valueField}`,
            type: attribute.type,
            sortable: true,
            filterable: true
          };
        }),
        {
          text: "",
          value: "actions",
          sortable: false,
          filterable: false,
          width: "100px",
          divider: true,
          align: "end"
        }
      ];

      return headers;
    }
  },
  methods: {
    updateProperty(itemId: string, field: string, value: any, origValue: any) {
      this.$emit("updateProperty", {
        itemId,
        field,
        value,
        origValue
      });
    }
  }
});
